(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabOnEventScriptsController', TabOnEventScriptsController);

    TabOnEventScriptsController.$inject = ['$scope', '$state', 'TabOnEventScripts', 'AlertService', '$uibModal'];

    function TabOnEventScriptsController($scope, $state, TabOnEventScripts, AlertService, $uibModal) {
        var vm = this;
        vm.tabOnEventScripts = [];
        vm.currentState = "tab-onEvent-scripts";
        vm.transition = transition;

        vm.loadAll = function () {

            TabOnEventScripts.query(onSuccess, onError);

            function onSuccess(data) {
                vm.tabOnEventScripts = [];
                vm.tabOnEventScripts = data;
                vm.transition();
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
            }, {notify: notify, location: "replace"});
        }

        vm.openDeleteDialog = function(name) {
            $uibModal.open({
                templateUrl: 'app/entities/tab-onEvent-scripts/tab-onEvent-scripts-delete-dialog.html',
                controller: 'TabOnEventScriptsDeleteController',
                controllerAs: 'vm',
                resolve: {
                    scriptName: function(){
                        return name;
                    }
                }
            }).result.then(function (scriptName) {
                TabOnEventScripts.delete({scriptName: scriptName},
                    function () {
                        vm.loadAll();
                    });
            }, function () {
            });
        };

        vm.loadAll();
    }
})();
